module.exports = __webpack_public_path__ + "static/media/stadconlogo.97cb0510.png";